import React from "react";
import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";
import ContentLoader from "react-content-loader";
import SpecialDaySelect from "./utilities/SpecialDaySelect";
import AddSpecialDaySelect from "./utilities/AddSpecialDaySelect";
import Button from "./utilities/Button";

const TableLoader = () => (
  <ContentLoader
    height={200}
    width={400}
    speed={2}
    primaryColor={"#f3f3f3"}
    secondaryColor={"#ecebeb"}
  >
    <rect
      x="101"
      y="16.05"
      rx="5"
      ry="5"
      width="220"
      height="16.299999999999997"
    />
    <rect x="101" y="50" rx="5" ry="5" width="220" height="10" />
    <rect x="101" y="74" rx="5" ry="5" width="220" height="10" />
    <rect x="100" y="100" rx="5" ry="5" width="220" height="10" />
  </ContentLoader>
);

class SpecialDays extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      handleCancel: null,
      confirm: false
    };
  }

  componentWillReceiveProps(newProps) {
    /*  if (!newProps.getDoctorSpecialDaysQuery.loading) {
      if (this.subscription) {
        if (
          newProps.getDoctorSpecialDaysQuery.allSpecialDays !==
          this.props.getDoctorSpecialDaysQuery.allSpecialDays
        ) {
          // if the feed has changed, we need to unsubscribe before resubscribing
          this.subscription();
        } else {
          // we already have an active subscription with the right params
          return;
        }
      }
      this.subscription = newProps.getDoctorSpecialDaysQuery.subscribeToMore({
        document: gql`
          subscription listenSpecialDay($doctorId: ID!) {
            SpecialDay(
              filter: {
                mutation_in: [CREATED, UPDATED, DELETED] # support update
                node: { doctor: { id: $doctorId } }
              }
            ) {
              mutation
              previousValues {
                id
              }
              updatedFields
              node {
                id
                date
                endDate
                dayTemplate {
                  id
                  name
                }
              }
            }
          }
        `,
        variables: {
          doctorId: this.props.doctorId
        },

        // this is where the magic happens
        updateQuery: (previousState, { subscriptionData }) => {
          const TYPE = subscriptionData.data.SpecialDay.mutation;
          if (TYPE === "DELETED") {
            return {
              ...previousState,
              allSpecialDays: [
                ...previousState.allSpecialDays.filter(
                  specialDay =>
                    specialDay.id !==
                    subscriptionData.data.SpecialDay.previousValues.id
                )
              ]
            };
          } else {
            const newSpecialDay = subscriptionData.data.SpecialDay.node;
            return {
              allSpecialDays: [
                ...previousState.allSpecialDays,
                {
                  ...newSpecialDay
                }
              ]
            };
          }
        },
        onError: err => console.error(err)
      });
    }*/
  }
  toggleConfirm = () => {
    this.setState({ confirm: !this.state.confirm });
  };

  handleCancel = () => {
    this.state.handleCancel();
  };
  setHandleCancel = handleCancel => {
    this.setState({ handleCancel });
  };

  render() {
    if (
      this.props.allDayTemplatesQuery.loading ||
      this.props.getDoctorSpecialDaysQuery.loading
    ) {
      return (
        <div className="columns  is-centered">
          <div className="column is-4 has-text-centered">
            <TableLoader />
          </div>
        </div>
      );
    } else {
      let specialDays = this.props.getDoctorSpecialDaysQuery.allSpecialDays.map(
        specialDay => {
          return (
            <SpecialDaySelect
              key={specialDay.id}
              specialDay={specialDay}
              options={this.props.allDayTemplatesQuery.allDayTemplates}
              toggleConfirm={this.toggleConfirm}
              setHandleCancel={this.setHandleCancel}
              refetch={this.props.getDoctorSpecialDaysQuery.refetch}
            />
          );
        }
      );
      return (
        <div
          style={{
            position: "relative",
            minHeight: "170px"
          }}
        >
          {this.state.confirm ? (
            <div className="modal-slot-overlay">
              <div className="modal-slot-overlay-content">
                <h1 className="title">Êtes-vous sûr?</h1>
                <p>
                  <Button
                    style={{
                      width: "100px"
                    }}
                    text="Retour"
                    onClick={this.toggleConfirm}
                  />
                  <Button
                    color="red"
                    text="Oui!"
                    onClick={this.handleCancel}
                    style={{
                      width: "100px"
                    }}
                  />
                </p>
              </div>
            </div>
          ) : null}
          {specialDays}
          <AddSpecialDaySelect
            options={this.props.allDayTemplatesQuery.allDayTemplates}
            doctorId={this.props.doctorId}
            refetch={this.props.getDoctorSpecialDaysQuery.refetch}
          />
        </div>
      );
    }
  }
}

const ALL_DAYTEMPLATES_QUERY = gql`
  query AllDayTemplatesQuery($doctorId: ID!) {
    allDayTemplates(
      filter: { doctor: { id: $doctorId } }
      orderBy: createdAt_ASC
    ) {
      id
      name
    }
  }
`;
const GET_DOCTOR_SPECIALDAYS_QUERY = gql`
  query GetDoctorSpecialDaysQuery($doctorId: ID!) {
    allSpecialDays(filter: { doctor: { id: $doctorId } }) {
      id
      date
      endDate
      dayTemplate {
        id
        name
      }
      #  doctor {
      #    id
      #  }
    }
  }
`;

export default compose(
  graphql(ALL_DAYTEMPLATES_QUERY, {
    name: "allDayTemplatesQuery",
    options: ({ doctorId }) => ({ variables: { doctorId } })
  }),
  graphql(GET_DOCTOR_SPECIALDAYS_QUERY, {
    name: "getDoctorSpecialDaysQuery",
    options: ({ doctorId }) => ({ variables: { doctorId } })
  })
)(SpecialDays);



// WEBPACK FOOTER //
// ./src/components/SpecialDays.js